.root {
  &[data-variant="success"] {
    &:active {
      color: light-dark(var(--mantine-color-success-10), var(--mantine-color-success-3));
      font-size: var(--mantine-font-size-sm);
    }
  }

  &[data-variant="danger"] {
    &:active {
      color: light-dark(var(--mantine-color-danger-7), var(--mantine-color-danger-3));
      font-size: var(--mantine-font-size-sm);
    }
  }
}
